import mqtt from 'mqtt'
import config from '@/config'
import SystemConnection, { CONNECTION_STATUS } from '@/utils/system/SystemConnection'
import TopicManager from './TopicManager'

const connectOptions = {
  protocolVersion: 5,
  keepalive: 60,
}

class MqttClient {
  constructor(url, options) {
    this.client = mqtt.connect(url, options)
    this.listenConnectionEvents()
  }

  getClient() {
    return this.client
  }

  listenConnectionEvents() {
    this.client.on('connect', () => {
      console.log('Connected to MQTT broker')
      SystemConnection.detectEmqxConnection(CONNECTION_STATUS.GOOD)
    })

    this.client.on('reconnect', () => {
      console.log('Reconnecting to MQTT broker')
      Object.keys(this.client._resubscribeTopics).forEach((topic) => {
        this.client.subscribe(topic)
      })
    })

    this.client.on('close', () => {
      console.log('Connection to MQTT broker closed')
      SystemConnection.detectEmqxConnection(CONNECTION_STATUS.ERROR)
    })

    this.client.on('error', () => {
      SystemConnection.detectEmqxConnection(CONNECTION_STATUS.ERROR)
    })

    this.client.on('offline', () => {
      SystemConnection.detectEmqxConnection(CONNECTION_STATUS.ERROR)
    })
  }

  subscribe(topic) {
    this.client.subscribe(topic)
    TopicManager.addTopic(topic)
  }

  unsubscribe(topic) {
    this.client.unsubscribe(topic)
    TopicManager.removeTopic(topic)
  }
}

const mqttClient = new MqttClient(config.mqttBrokerUrl, connectOptions)

export default mqttClient.getClient()
